// components/Atoms/index.js
export { default as Avatar } from './Avatar';
// export { default as Icon } from './Icon';
export { default as CTA } from './CTA';
export { default as Card } from './Card';
export { default as Embed } from './Embed';
export { default as Button } from './Button';
export { default as Image } from './Image';
export { default as Input } from './Input';
export { default as Link } from './Link';
export { default as Logo } from './Logo';
export { default as Status } from './Status';
export { default as Chip } from './Chip';
export { default as Modal } from './Modal';
export { default as MediaBlock } from './MediaBlock';
export { default as Paragraph } from './Paragraph';